












































import { Component, Prop, Watch } from 'vue-property-decorator';
import CommonVue from '../../models/commonVue';
import Draggable from 'vuedraggable';
import EditIcon from '@/components/icons/EditIcon.vue';
import ApiList from '@/api/list';
import Courses from '@/api/course';
import { BusEvent } from '@/models/bus';

@Component({
  components: {
    draggable: Draggable,
    'edit-icon': EditIcon
  }
})
export default class ListCourse extends CommonVue {
  @Prop() public courses!: Promise<ApiList<Courses>>;
  @Prop({ type: Boolean, default: false }) public isEdit!: boolean;
  
  public courseList: ApiList<Courses> | null = null;

  public async beforeMount() {
    // this.busy = true;
    await this.loadList();
    // this.busy = false;
  }

  @Watch('courses')
  public async loadList() {
    // this.busy = true;
    try {
      this.courseList = await this.courses;
    } catch (e) {
      this.error = true;
      this.$bus.$emit(BusEvent.ERROR, 'Could not load list', e);
    }
    // finally {
    //   this.busy = false;
    // }
  }

  public editCourse(courseId: number, e) {
    e.stopPropagation();
    this.$router.push(
      `/${this.COURSES_SLUG}/${courseId}`
    );
  }
}
